import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const GA_MEASUREMENT_ID = "G-4B3ET5TW3E";

/**
 * Fires a GA4 page_view event on every route change (including the initial
 * load). gtag is loaded by /public/index.html with send_page_view:false, so
 * this component is the single source of truth for page-view tracking.
 */
export default function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    if (typeof window === "undefined" || typeof window.gtag !== "function") return;

    const page_path = `${location.pathname}${location.search}${location.hash}`;
    const page_title = document.title;
    const page_location = window.location.href;

    window.gtag("event", "page_view", {
      page_path,
      page_title,
      page_location,
      send_to: GA_MEASUREMENT_ID,
    });
  }, [location]);

  return null;
}
